import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux';
import { selectCanvasDetails } from 'store/canvas/selectors'
import { selectShowButton } from 'store/intl/selectors'
import { withPaint } from 'store/canvas/withPaint'
import { withContextRouter } from '../../renderer/utils/withRouter'
import { withAssets } from '../../renderer/utils/withAssets'
import { selectCanvasBackgroundColor } from 'store/preferences/selectors'
import ReduxElementSwitcher from './ReduxElementSwitcher'
import ElementSelector from './ElementSelector'
import inCartApi from 'apis/incartApis'
import cmsApis from 'apis/cmsApis'

const mapStateToProps = (state) => ({
  elements: selectCanvasDetails(state),
  showButton: selectShowButton(state),
  canvasBackground: selectCanvasBackgroundColor(state),
});

const CoreEngine = compose(
  connect(mapStateToProps),
  withPaint(),
  withContextRouter(),
  withAssets(),
)(
  ({
    elements,
    selectElement,
    canvasBackground,
  }) => (
    <div
      className="core-engine"
      onClick={() => selectElement(null)}
      style={{ backgroundColor: canvasBackground }}
    >
      {elements.map((elementId, i) => (
        [
          <ElementSelector
            key={elementId}
            parentId={null}
            refElement={null}
            selectorId={`root-${elementId}`}
            elementIndex={i}
          />,
          <ReduxElementSwitcher
            api={{
              fetchProductDetail: inCartApi.getProduct,
              fetchProductList: inCartApi.getProductList,
              fetchMenuDetail: cmsApis.getMenus,
            }}
            parents={[]} // at initial
            elementId={elementId}
            EnhancedSwitcher={ReduxElementSwitcher}
          />,
        ]
      ))}
      <ElementSelector
        parentId={null}
        refElement={null}
        selectorId="last-root-selector"
        elementIndex={elements.length}
        emptyMode
      />
    </div>
  ),
)

CoreEngine.propTypes = {}
CoreEngine.defaultProps = {}

export default CoreEngine



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/core/CoreEngine.js